<template>
	<div class="type-icon">
		<font-awesome-icon :icon="getIcon()" />
	</div>
</template>
<script>
import { ALERTS } from './constants.js';

export default {
	name: 'AlertTypeIcon',
	props: {
		alertType: String,
	},
	data() {
		return {
			iconList: ALERTS.TYPE_ICONS,
		};
	},
	methods: {
		getIcon() {
			return this.iconList.find((obj) => obj.type === this.alertType).icon;
		},
	},
};
</script>

<style lang="scss" scoped>
.type-icon {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	border: 1px solid $border-color-light;
	background: $white;
	@include rem('width', 44px);
	@include rem('height', 44px);
	@include rem('font-size', 20px);
}
</style>
